import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from 'ng2-translate';



import {
    Candidature,
    /*CandidatureFormation,*/
    CandidatureFormationOrder/*,
    CandidatureFormationService*/
} from '../candidature';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../cadens.constants';
import {Parametrage, ParametrageService} from '../parametrage';
import {ExportService, Principal} from '../../shared';
import {ConfirmationService} from 'primeng/components/common/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AideComponent} from '../../admin';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CategorieFormationService, FormationService, Formation, Piece, PieceService} from '../formation';
import {PieceJointe, PieceJointeService} from '../piece-jointe';
import {CandidatureFormationService, CandidatureFormation} from '../candidature';
//import {CandidatureFormation} from '../candidature';
import {Commission, CommissionService} from '../commission';



@Component({
    selector: 'jhi-espace-candidat',
    templateUrl: 'espaceCandidat.component.html'
})
export class EspaceCandidatComponent implements OnInit, OnChanges {
    @Input() isSaving: Boolean;
    @Input() isEditable = true;
    @Input() isConfirmable = false;
    @Input() isClickable = false;
    @Input() isAfterLimite = false;
    @Input() isBO: number; // 0=candidat ; 1=BO lecture seule; 2=BO Modifiable
    @Input() candidatureFormationId: Number = null;
    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() missingPieces: Boolean;
    @Output() missingPiecesChange: EventEmitter<Boolean> = new EventEmitter();
    piecesJointes: PieceJointe[] = [];
    maxSize = 2000000;
    pieces: Piece[] = [];
    otherUploadedFiles: any[] = [];
    attestationCandidat: Piece;
    lastIdx: number;
    alertId: number;
    choixConfirmation: number;
    private modalRef: NgbModalRef;
    private ngInitDone = false;
    private isReloading = false;
    candidatures: Candidature[];
    cfOrdreModifiable: CandidatureFormation[];
    cfOrdreNonModifiable: CandidatureFormation[];
    cfEnCoursOuSupprimmee: CandidatureFormation[];
    cfListeDesOrdres: CandidatureFormationOrder[];
    error: any;
    success: any;
    currentLang: string;
    parametrage: any;
    public constants = CONSTANTS;
    draggedCandidature: CandidatureFormation;
    formationsOpen = false;
    acceptLabel = 'delete';
    aide: Parametrage;
    reinscription = false;
    candidatureAutorisee = true;
    isLoading: boolean;
    nomFichierAide: string;


    // private reorder: any[] = [];

    private static sortByDateCreation(a: CandidatureFormation, b: CandidatureFormation): number {
        if (a.dateCreation > a.dateCreation) {
            return 1;
        } else {
            return -1;
        }
    }

    private static sortByOrder(a: CandidatureFormation, b: CandidatureFormation): number {
        if (a.ordre !== null && b.ordre !== null) {
            if (a.ordre !== b.ordre) {
                if (a.ordre > b.ordre) {
                    return 1;
                } else {
                    return -1;
                }
            }
        } else {
            if (a.ordre !== null) {
                return 1;
            }
            if (b.ordre !== null) {
                return -1;
            }
        }
        if (a.dateCreation !== null && b.dateCreation !== null) {
            if (a.dateCreation < b.dateCreation) {
                return 1;
            } else {
                return -1;
            }
        }
        return 0;
    }

    private static isbefore(a, b) {
        if (a.parentNode === b.parentNode) {
            for (let cur = a; cur; cur = cur.previousSibling) {
                if (cur === b) {
                    return true;
                }
            }
        }
        return false;
    }
    private static getCookie(name) {
        let value = '; ' + document.cookie;
        let parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }
    constructor(private candidatureFormationService: CandidatureFormationService,
                private principal: Principal,
                private jhiLanguageService: JhiLanguageService,
                private parametrageService: ParametrageService,
                private categorieFormationService: CategorieFormationService,
                private alertService: AlertService,
                private router: Router,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private modalService: NgbModal,
                private exportService: ExportService,
                private translate: TranslateService,
                private formationService: FormationService,
                private commissionService: CommissionService,
                private pieceJointeService: PieceJointeService,
                private pieceService: PieceService
    ) {
        this.jhiLanguageService.setLocations(['candidature', 'global']);
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    /**
     * ngOnInit is called when the page is loaded
     * Load the candidatures and the parametrage for the page (contains some libelles)
     */
    ngOnInit() {
        this.loadAll();
        this.parametrageService.query({page: CONSTANTS.ESPACECANDIDAT}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        this.rechercheNomFichierAide();

        this.ngInitDone = true;

        this.otherUploadedFiles = [];

        this.ngInitDone = true;


    }
    /**
     * Check if one of the PJ is mandatory and missing
     */
    private isMissingPJ() {
        if (this.pieces != null && this.pieces.length > 0) {
            if (this.piecesJointes == null || this.piecesJointes.length === 0) {
                this.missingPieces = true;
            } else {
                let piecesMandat = this.pieces.filter(p => p.obligatoire === true);
                let pjMandat = this.piecesJointes.filter(pj => piecesMandat.findIndex(p => p.id === pj.pieceId) > -1);
                this.missingPieces = piecesMandat.length > pjMandat.length;
            }
        } else {
            this.missingPieces = false;
        }
        this.missingPiecesChange.emit(this.missingPieces);
    }
    formatDate(date: Date): string {
        if (!date) return '';

        if (this.currentLang === 'fr') {
            return date.toLocaleDateString('fr-FR', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } else {
            return date.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    }
    getTimezoneInfo(isSummer: boolean): {timezoneInfo: string, additionalInfo: string} {
        let timezoneInfoKey, additionalInfoKey;
        if (isSummer) {
            timezoneInfoKey = 'cadensApp.candidature.dateLimiteConfirmationEte';
            additionalInfoKey = 'cadensApp.candidature.dateLimiteConfirmationInformation2Ete';
        } else {
            timezoneInfoKey = 'cadensApp.candidature.dateLimiteConfirmationHiver';
            additionalInfoKey = 'cadensApp.candidature.dateLimiteConfirmationInformation2Hiver';
        }

        return {
            timezoneInfo: this.translateService.instant(timezoneInfoKey),
            additionalInfo: this.translateService.instant(additionalInfoKey)
        };
    }
    isSummerTime(date: Date): boolean {
        const year = date.getFullYear();
        const lastSundayMarch = this.getLastSundayInMarch(year);
        const lastSundayOctober = this.getLastSundayInOctober(year);

        return date >= lastSundayMarch && date < lastSundayOctober;
    }

    getLastSundayInMarch(year: number): Date {
        const march31 = new Date(year, 2, 31); // Mars est le mois 2 (0-indexed)
        const dayOfWeek = march31.getDay();
        const lastSunday = march31.getDate() - ((dayOfWeek === 0) ? 7 : dayOfWeek);
        return new Date(year, 2, lastSunday);
    }

    getLastSundayInOctober(year: number): Date {
        const october31 = new Date(year, 9, 31); // Octobre est le mois 9 (0-indexed)
        const dayOfWeek = october31.getDay();
        const lastSunday = october31.getDate() - ((dayOfWeek === 0) ? 7 : dayOfWeek);
        return new Date(year, 9, lastSunday);
    }

    /****
     * ngOnChanges is called where change on page
     * ****/
    ngOnChanges(changes: any) {
        if (((changes['candidatureFormation'] != null
                && changes['candidatureFormation'].previousValue.id != null
                && changes['candidatureFormation'].previousValue.id !== changes['candidatureFormation'].currentValue.id) ||
                (changes['candidatureFormationId'] != null
                    && changes['candidatureFormationId'].previousValue != null
                    && changes['candidatureFormationId'].previousValue !== changes['candidatureFormationId'].currentValue) ||
                (changes['candidatureFormationFc'] != null
                    && changes['candidatureFormationFc'].previousValue != null
                    && changes['candidatureFormationFc'].previousValue !== changes['candidatureFormationFc'].currentValue)
            )
            && !this.isReloading
            && this.ngInitDone) {
            this.isReloading = true;

            this.otherUploadedFiles = [];

        }
    }

    /**
     * Load all the candidatures from candidatureFormation for the connected user
     */
    loadAll() {
        this.principal.identity().then((account) => {
            if (account.etudiant != null && account.etudiant.numeroEtudiant != null) {
                this.reinscription = true;
            } else {
                if (account.email.endsWith('@ens-lyon.fr')) {
                    this.candidatureAutorisee = false;
                }
            }
            this.isLoading = true;
            this.candidatureFormationService.query({userId: account.id}).subscribe(
                (resCandidature: Response) => {
                    this.candidatureFormationService.findCandidatureOrdre({userId: account.id}).subscribe(
                        (resOrdre: Response) => {
                            const candidatureJson: CandidatureFormation[] = resCandidature.json();
                            const candidaturesAvecFormation = candidatureJson.filter(cf => cf.formationId != null);
                            const candidaturesAvecCommission = candidatureJson.filter(cf => cf.commissionId != null);

                            // Ne pas chercher les formations ou commissions si candidaturesAvecFormation est vide
                            if (candidaturesAvecFormation.length === 0) {
                                this.onSuccess(candidatureJson, resOrdre.json());
                                this.isLoading = false;
                            } else {


                                // Initialisation des formations et des commissions en parallèle
                                const formationRequests = candidaturesAvecFormation.length > 0
                                    ? candidaturesAvecFormation.map(cf => this.formationService.find(cf.formationId))
                                    : [];
                                // test pour recharger la date de commission si celle-ci est modifiée et que l'ancienne date reste en cache
                                const commissionRequests = candidaturesAvecCommission.length > 0
                                    ? candidaturesAvecCommission.map(cf => this.commissionService.find(cf.commissionId))
                                    : [];

                                forkJoin<[Formation[], Commission[]]>([
                                    ...formationRequests,
                                    ...commissionRequests
                                ]).subscribe(
                                    (res: Array<Formation | Commission>) => {
                                        // Traitement des résultats pour les formations
                                        if (formationRequests.length > 0) {
                                            const formationResults = res.slice(0, formationRequests.length) as Formation[];
                                            candidaturesAvecFormation.forEach((cf, i) => {
                                                cf.formation = formationResults[i];
                                            });
                                        }
                                        // Traitement des résultats pour les commissions
                                        if (commissionRequests.length > 0) {
                                            const commissionResults = res.slice(formationRequests.length) as Commission[];
                                            candidaturesAvecCommission.forEach((cf, i) => {
                                                cf.commissionObject = commissionResults[i];
                                            });
                                        }
                                        // Tout est prêt, on appelle onSuccess
                                        this.onSuccess(candidatureJson, resOrdre.json());
                                        this.isLoading = false;
                                    },
                                    (err) => {
                                        this.isLoading = false;
                                        this.onError(err);
                                    }
                                );
                            }
                        },
                        (resOrdre: Response) => {
                            this.isLoading = false;
                            this.onError(resOrdre);
                        }
                    );
                },
                (resCandidature: Response) => {
                    this.isLoading = false;
                    this.onError(resCandidature);
                }
            );
            this.categorieFormationService.queryDisponibles({
                etudiantId: account.id,
                reinscription: this.reinscription,
                lecture: false
            }).subscribe(
                (res: Response) => {
                    let cats = res.json();
                    if (cats && cats.length > 0) {
                        if (cats.find(cat => !cat.disabled)) {
                            this.formationsOpen = true;
                        }
                    }
                });
        });
    }


    isAfterDateLimiteConfirmation(candidatureFormation: CandidatureFormation): boolean {
        if (!candidatureFormation.formation || !candidatureFormation.formation.campagnes || !candidatureFormation.commissionObject) {
            console.warn('Commission ou formation non définie pour la candidature :', candidatureFormation);
            return null;
        }
        const dateLimiteConfirmation = new Date(candidatureFormation.commissionObject.dateLimiteConfirmation);
        console.log('Date limite de confirmation :', dateLimiteConfirmation); // Log pour vérifier la date
        const aujourdhui = new Date();
        return aujourdhui > dateLimiteConfirmation;
    }
    private onSuccess(candidatureJson, ordreJson) {
        this.cfListeDesOrdres = ordreJson;
        let cfAll: CandidatureFormation[];
        cfAll = candidatureJson;

        cfAll.forEach(candidature => {
            candidature.ordreModifiable = false;
            if (this.cfListeDesOrdres !== null) {
                this.cfListeDesOrdres.forEach(ordre => {
                    if (ordre.id === candidature.id) {
                        candidature.ordre = ordre.ordre;
                        if (ordre.ordreModifiable !== null) {
                            candidature.ordreModifiable = ordre.ordreModifiable;
                        }
                    }
                });
            }
        });

        this.cfEnCoursOuSupprimmee = cfAll
            .filter(candi => candi.dateSuppression !== null || candi.dateValidation === null)
            .sort(EspaceCandidatComponent.sortByDateCreation);
        this.cfOrdreModifiable = cfAll
            .filter(candi => !(candi.dateSuppression !== null || candi.dateValidation === null) && candi.ordreModifiable === true)
            .sort(EspaceCandidatComponent.sortByOrder);
        this.cfOrdreNonModifiable = cfAll
            .filter(candi => !(candi.dateSuppression !== null || candi.dateValidation === null) && candi.ordreModifiable === false)
            .sort(EspaceCandidatComponent.sortByOrder);
    }


    /**
     * Redirect to the candidature on button click
     * @param id
     */
    open(id) {
        this.router.navigate(['/candidature/' + id]);
    }

    delete(id) {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.delete.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.delete.title'),
            icon: 'fa fa-trash',
            key: 'confirmDelete',
            accept: () => {
                this.isLoading = true;
                this.candidatureFormationService.delete(id).subscribe(res => {
                        this.loadAll();
                    },
                    (res) => {
                        this.isLoading = false;
                        this.onError(res);
                    });
            }
        });
    }

    /**
     * Le candidat se désiste pour une candidature
     * @param candidatureFormation
     */
    desistResponse(candidatureFormation: CandidatureFormation) {
        this.acceptLabel = 'desist';
        const messageValue = candidatureFormation.response === CONSTANTS.AWAITING ?
            'cadensApp.espaceCandidat.desist.questionLC' : 'cadensApp.espaceCandidat.desist.question';
        this.confirmationService.confirm({
            message: this.translateService.instant(messageValue),
            header: this.translateService.instant('cadensApp.espaceCandidat.desist.title'),
            icon: 'fa fa-ban',
            accept: () => {
                this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation],
                    {statut: CONSTANTS.DESISTED}).subscribe(res => {
                    this.loadAll();
                });
            }
        });
    }
    onChangeChoix(newChoix) {
        this.isClickable = true;
        this.otherUploadedFiles = [];
    }
    /**
     * Le candidat confirme sa venue pour une candidature
     * @param candidatureFormation
     */
    confirmResponse(candidatureFormation: CandidatureFormation) {
        this.acceptLabel = 'confirm';
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.confirm.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.confirm.title'),
            icon: 'fa fa-handshake-o',
            accept: () => {
                this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation],
                    {statut: CONSTANTS.CONFIRMED}).subscribe(res => {
                    this.loadAll();
                });
            }
        });
    }
    confirmResponseAvecChoix(candidatureFormation: CandidatureFormation, choix?: number) {
        this.acceptLabel = 'confirm';
        this.choixConfirmation = choix;
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.espaceCandidat.confirm.question'),
            header: this.translateService.instant('cadensApp.espaceCandidat.confirm.title'),
            icon: 'fa fa-handshake-o',
            accept: () => {
                this.candidatureFormationService.updateCandidaturesStatus([candidatureFormation],
                    {statut: CONSTANTS.CONFIRMED, choixConfirmation: this.choixConfirmation}).subscribe(res => {
                    this.loadAll();
                });
            }
        });
    }

    /** MANAGE Ordre des candidature par DragNDrop (https://www.primefaces.org/primeng/#/dragdrop) **/
    dragStart(event, candidatureF: CandidatureFormation) {
        if (event.target.nodeName === 'LI' && candidatureF.dateSuppression == null && candidatureF.dateValidation != null) {
            // Quand le user pick une candidature, l'enregistrer
            this.draggedCandidature = event.target;
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    dragEnd(event) {
        // A la fin du drag&drop, enregistrer le nouvel ordre!
        let updates = [];
        this.cfOrdreModifiable.forEach(candidatureFormation => {
            updates.push(candidatureFormation);
        });
        // this.reorder.forEach((candi, index) => {
        //     let candidatureFormation = this.cfOrdreModifiable.find(cf => cf.id === Number(candi));
        //     candidatureFormation.ordre = index + 1;
        //     updates.push(candidatureFormation);
        // });
        if (updates.length > 0) {
            this.isLoading = true;
            this.candidatureFormationService.updateCandidaturesOrder(updates).subscribe(
                res => {
                    this.loadAll();
                },
                error => {
                    this.isLoading = false;
                    this.onError({message: 'cadensApp.candidature.messages.error.modificationOrdre'});
                }
            );
        }
        this.draggedCandidature = null;
    }

    dragEnter(event) {
        let target = event.target;
        if (target.nodeName === 'LI' && this.draggedCandidature) {
            if (target.attributes.getNamedItem('draggable') != null) {
                // Appelé pendant le drag&drop process, permet d'insérer un LI avant/après un autre
                if (EspaceCandidatComponent.isbefore(this.draggedCandidature, target)) {
                    target.parentNode.insertBefore(this.draggedCandidature, target);
                } else {
                    target.parentNode.insertBefore(this.draggedCandidature, target.nextSibling);
                }
                if (target.parentNode.id === 'parentUL') {
                    // Récupérer l'ordre des 'LI' à chaque fois que ça change
                    // this.reorder = [];
                    // L'id des candidature est l'ID du 'LI'
                    let minOrdre: number = Math.min(...this.cfOrdreModifiable.map(function (o) {
                        return o.ordre;
                    }));
                    for (let i in target.parentNode.children) {
                        // this.reorder.push(target.parentNode.children[i].id) ;
                        this.cfOrdreModifiable.filter(candidature => {
                            // noinspection JSUnfilteredForInLoop
                            return candidature.id.toString() === target.parentNode.children[i].id;
                        }).forEach(candidatureTrouvee => {
                            // noinspection JSUnfilteredForInLoop
                            candidatureTrouvee.ordre = minOrdre;
                        });
                        minOrdre++;
                    }
                }
            }
        }
    }

    drop(event) {
        this.draggedCandidature = null;
    }

    // Open la popup d'aide
    openAide(aideModal) {
        this.modalService.open(aideModal);
    }


    // Generation du document suivants status acceptation, refus, attente
    genererLettreAdmission(candiId: number, pourReponseCode: string, sortieListeComplementaire: Boolean) {
        let lc: String = '_';
        if (sortieListeComplementaire === true) {
            lc = 'lc';
        }
        let fileName: String = 'reponseENS' + lc + candiId + '.pdf';
        this.candidatureFormationService.genererLettreAdmission(candiId, pourReponseCode, sortieListeComplementaire).subscribe((res) => {
                ExportService.download(res, fileName);
            },
            (error => {
                this.onError({message: 'cadensApp.candidature.messages.error.genererLettreAdmission'});
            }));
    }

    private onSuccessOLD(candidatureJson, ordreJson) {
        this.cfListeDesOrdres = ordreJson;
        let cfAll: CandidatureFormation[];
        cfAll = candidatureJson;

        cfAll.forEach(candidature => {
            candidature.ordreModifiable = false;
            if (this.cfListeDesOrdres !== null) {
                this.cfListeDesOrdres.forEach(ordre => {
                    if (ordre.id === candidature.id) {
                        candidature.ordre = ordre.ordre;
                        if (ordre.ordreModifiable !== null) {
                            candidature.ordreModifiable = ordre.ordreModifiable;
                        }
                    }
                });
            }
        });

        this.cfEnCoursOuSupprimmee = cfAll
            .filter(candi => candi.dateSuppression !== null || candi.dateValidation === null)
            .sort(EspaceCandidatComponent.sortByDateCreation);
        this.cfOrdreModifiable = cfAll
            .filter(candi => !(candi.dateSuppression !== null || candi.dateValidation === null) && candi.ordreModifiable === true)
            .sort(EspaceCandidatComponent.sortByOrder);
        this.cfOrdreNonModifiable = cfAll
            .filter(candi => !(candi.dateSuppression !== null || candi.dateValidation === null) && candi.ordreModifiable === false)
            .sort(EspaceCandidatComponent.sortByOrder);
    }

    protected onError(error) {
        this.alertService.error(error.message, null, null);
    }

    private rechercheNomFichierAide() {
        this.parametrageService.getFileName(AideComponent.categorieAide, 'ROLE_USER').subscribe(
            (res: Response) => {
                if (res !== null && res.text() !== null && res.text().length > 0) {
                    this.nomFichierAide = res.text();
                }
            }
            ,
            (res: Response) => this.onError(res)
        );
    }

    protected openFichierAide() {
        this.parametrageService.getFile(AideComponent.categorieAide, 'ROLE_USER').subscribe(
            (file: Blob) => {
                ExportService.download(file, 'ROLE_USER');
            },
            (response) => {
                this.onError(response);
            });
    }

    /****** Televerser attestation*/

    // Open la popup d'aide
    openModalConfirmationEcts180(otherPieceModalAttestation) {
        this.modalService.open(otherPieceModalAttestation);
    }
    // Open a file in a new tab when click on it
    openFile(name: string) {
        // Get la liste des pièces jointes déjà uploadées
        this.pieceJointeService.openFile(name).subscribe((res) => {
                let fileUrl = URL.createObjectURL(res);
                window.open(fileUrl);
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }
    // Autres pièces justificatives
    addOtherPJ(modal, idx?: number, choix?: number, candidatureFormation?: CandidatureFormation) {
        this.modalRef = this.modalService.open(modal);
        this.choixConfirmation = choix;
        this.candidatureFormation = candidatureFormation;
        if (!this.otherUploadedFiles) {
            this.otherUploadedFiles = [];
        }
        if (idx !== null) {
            this.lastIdx = idx;
        } else {
            this.otherUploadedFiles.push({pieceId: 1});
            if (choix === 1) {
                this.otherUploadedFiles.push({notes: "Attestation sur l'honneur"});
            } else {
                this.otherUploadedFiles.push({notes: 'Attestation de démission'});
            }
            this.lastIdx = this.otherUploadedFiles.length - 1;

        }
    }

    closeOtherPJ() {
        if (this.otherUploadedFiles[this.lastIdx].id === null) {
            this.otherUploadedFiles.pop();
        }
        this.modalRef.close();
    }
    // Before the file is sent to the server for upload
    // noinspection JSMethodCanBeStatic
    onBeforeSend(event) {
        event.xhr.setRequestHeader('X-XSRF-TOKEN', EspaceCandidatComponent.getCookie('XSRF-TOKEN'));
    }
    // Before the file is sent to the server for upload
    onBeforeUpload(event, id) {
        this.onBeforeUploadAttestation(event, id);
    }
// Before the file is sent to the server for upload
    onBeforeUploadAttestation(event, id) {
        event.formData.append('pieceId', id);
        if (this.otherUploadedFiles != null && id === 1 && this.lastIdx != null
            && this.otherUploadedFiles[this.lastIdx] != null) {
            event.formData.append('pieceJointeId',
                this.otherUploadedFiles[this.lastIdx].id == null ? -1 : this.otherUploadedFiles[this.lastIdx].id);
        }
        this.alertId = id;
        event.formData.append('candidatureFormationId', this.candidatureFormation.id);
       /* if (referentId != null) {
            event.formData.append('referentId', referentId);
        }*/
    }
    onOtherFileUploaded(event) {
        let pj: PieceJointe = JSON.parse(event.xhr.response);
        let notes = this.otherUploadedFiles[this.lastIdx].notes;
        this.otherUploadedFiles[this.lastIdx] = pj;
        this.otherUploadedFiles[this.lastIdx].notes = notes;
    }

    saveOtherPJ(modal, choix?: number) {

        if (this.otherUploadedFiles[this.lastIdx].nom !== null) {

            this.pieceJointeService.update(this.otherUploadedFiles[this.lastIdx]).subscribe((res) => {

                    this.otherUploadedFiles[this.lastIdx] = res;
                    this.modalRef.close();
                },
                error => {
                    this.isSaving = false;
                    this.onError(error);
                });

            // confirmation de la venue
            this.choixConfirmation = choix;
            this.confirmResponseAvecChoix(this.candidatureFormation, this.choixConfirmation);
        }

    }
    deleteOtherPJ() {
        this.pieceJointeService.delete(this.otherUploadedFiles[this.lastIdx].id).subscribe((res) => {
                this.otherUploadedFiles.splice(this.lastIdx, 1);
                this.modalRef.close();
            },
            error => {
                this.isSaving = false;
                this.onError(error);
            });
    }
    ngOnInitPj() {
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        this.isSaving = true;
        if (this.candidatureFormation != null && this.candidatureFormation.id != null && this.candidatureFormation.formationId != null) {

        }
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/espaceCandidat/espaceCandidat.component.ts